/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Add_Member_SubmitInputs */

const th_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่ม`)
};

const en_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const ja_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

const zh_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加`)
};

const es_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir`)
};

const pt_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar`)
};

const id_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah`)
};

const fr_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

const tl_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idagdag`)
};

const vi_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm`)
};

const ko_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추가`)
};

const de_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

const ru_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить`)
};

const tr_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekle`)
};

const it_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi`)
};

const pl_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj`)
};

const uk_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додати`)
};

const hi_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जोड़ें`)
};

const ar_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة`)
};

const ms_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah`)
};

const bn_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যোগ করুন`)
};

const zh_tw2_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增`)
};

const zh_hk2_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增`)
};

const ur_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شامل کریں`)
};

const fa_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افزودن`)
};

const sw_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeza`)
};

const nl_org_add_member_submit = /** @type {(inputs: Org_Add_Member_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toevoegen`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Org_Add_Member_SubmitInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_add_member_submit = /** @type {((inputs?: Org_Add_Member_SubmitInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Add_Member_SubmitInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_add_member_submit(inputs)
	if (locale === "ja") return ja_org_add_member_submit(inputs)
	if (locale === "zh") return zh_org_add_member_submit(inputs)
	if (locale === "es") return es_org_add_member_submit(inputs)
	if (locale === "pt") return pt_org_add_member_submit(inputs)
	if (locale === "id") return id_org_add_member_submit(inputs)
	if (locale === "fr") return fr_org_add_member_submit(inputs)
	if (locale === "tl") return tl_org_add_member_submit(inputs)
	if (locale === "vi") return vi_org_add_member_submit(inputs)
	if (locale === "ko") return ko_org_add_member_submit(inputs)
	if (locale === "de") return de_org_add_member_submit(inputs)
	if (locale === "ru") return ru_org_add_member_submit(inputs)
	if (locale === "tr") return tr_org_add_member_submit(inputs)
	if (locale === "it") return it_org_add_member_submit(inputs)
	if (locale === "pl") return pl_org_add_member_submit(inputs)
	if (locale === "uk") return uk_org_add_member_submit(inputs)
	if (locale === "hi") return hi_org_add_member_submit(inputs)
	if (locale === "ar") return ar_org_add_member_submit(inputs)
	if (locale === "ms") return ms_org_add_member_submit(inputs)
	if (locale === "bn") return bn_org_add_member_submit(inputs)
	if (locale === "zh-TW") return zh_tw2_org_add_member_submit(inputs)
	if (locale === "zh-HK") return zh_hk2_org_add_member_submit(inputs)
	if (locale === "ur") return ur_org_add_member_submit(inputs)
	if (locale === "fa") return fa_org_add_member_submit(inputs)
	if (locale === "sw") return sw_org_add_member_submit(inputs)
	if (locale === "nl") return nl_org_add_member_submit(inputs)
	return en_org_add_member_submit(inputs)
});